@reference "@glow/tailwind-config/reference.css";

/* Vite drops Tailwind's layer-order statement from the app bundle, and this chunk loads
   before it, so the order must be declared here or base ends up before theme */
@layer properties, theme, base, components, utilities;

/*
 * Size and weight stay UNLAYERED so they beat v4 preflight's `h1-h6 { font-size: inherit;
 * font-weight: inherit }` (in @layer base) when a Text renders as a heading via `as`.
 * Color goes in @layer components so a consumer's `text-emphasis-*` utility (in @layer
 * utilities, which sorts after components) overrides the default. No @layer base rule sets
 * text color, so nothing in base beats these component-layer colors.
 */

.textType-4xl {
  @apply text-4xl;
  @apply font-bold;
}
.textType-3xl {
  @apply text-3xl;
}
.textType-2xl {
  @apply text-2xl;
}
.textType-xl {
  @apply text-xl;
  @apply font-semibold;
}
.textType-lg {
  @apply text-lg;
  @apply font-semibold;
}
.textType-base {
  @apply text-base;
  @apply font-normal;
}
.textType-base-black {
  @apply text-base;
  @apply font-normal;
}

.textType-sm {
  @apply text-sm;
  @apply font-normal;
}
.textType-sm-black {
  @apply text-sm;
  @apply font-normal;
}

.textType-xs {
  @apply text-xs;
  @apply font-normal;
}

.textType-xs-black {
  @apply text-xs;
  @apply font-normal;
}

.semiBold {
  @apply font-semibold;
}

@layer components {
  .textType-4xl,
  .textType-3xl,
  .textType-2xl,
  .textType-xl,
  .textType-lg,
  .textType-base-black,
  .textType-sm-black,
  .textType-xs-black {
    @apply text-emphasis-high;
  }
  .textType-base,
  .textType-sm,
  .textType-xs {
    @apply text-emphasis-medium;
  }
}
